export default {
      id: "help__login_icon-usage",
      viewBox: "0 0 45 45",
      url: __webpack_public_path__ + "img/icons.svg#help__login_icon",
      toString: function () {
        return this.url;
      }
    }